<div>
    <app-breadcrumb></app-breadcrumb>
    <h2 class="roboto-medium title ms-4 me-4">AET KPI</h2>
  </div>


  <div
    class="
      d-flex
      justify-content-between
      mt-3
      mb-1
      align-items-center
      icon-container
      ms-4
      me-4
    "
  >

  </div>
  <div class="kpi-container mb-5 pb-5 ms-4 me-4">


  <mat-accordion >
    <mat-expansion-panel #panel  class="mat-elevation-z0" (opened)="openBar()">
      <mat-expansion-panel-header class="header-container">
        <mat-panel-title> </mat-panel-title>
        <mat-panel-description  class="bardesc">
          Total number of Abnormals
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div
      class="px-3"
      *ngIf="errorMessage != null"
      class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4"
      role="alert"
    >
      <button
        type="button"
        class="btn-close"
        (click)="close()"
        data-bs-dismiss="alert"
        aria-label="close"
      ></button>
      <strong>{{ errorMessage }}</strong>
    </div>
    <div class="row d-flex
        mt-2
        icon-container
        ms-4
        kpibuttons">
        <img
              src="./assets/images/refresh_button.svg" title="Refresh" (click)="onBarClicked()"
              style="width:60.5px; margin-top: 5px;cursor:pointer;"
            />
      <img
        src="./assets/images/export_black.svg" title="Export"
        (click)="onBtExport()"
        style="width:47px; margin-bottom: 10px;cursor:pointer;"
      />
   </div>

      <div class="row">
        <div class="col-2">
          <div class="row spacing">
            <div class="col-6"><label for="start">Start Date</label></div>
            <div class="col-6">
              <input type="date" style="width: 134px;" [(ngModel)]="startDateBar"  onkeydown="return false" />
            </div>
          </div>

          <div class="row spacing">
            <div class="col-6"><label for="end">End Date</label></div>
            <div class="col-6">
              <input type="date" style="width: 135px;" [max]="maxDate" [(ngModel)]="endDateBar" onkeydown="return false" />
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6"><label for="end">Domicile</label></div>
            <div class="col-6">
                <mat-select
                  [(ngModel)]="selectedDomicileBar"
                  placeholder=""
                  class="dropdownOptions mat-sel diff"
                  style="width:200px"

                >
                  <mat-option *ngFor="let option of dropdownOptionDomicileBar" [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select>
              
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6"><label for="end">Event Type</label></div>
            <div class="col-6">
                <!-- <mat-select
                  multiple
                  required
                  [(ngModel)]="selectedEventBar"
                  placeholder=""
                  [disableOptionCentering]="true"
                  class="mat-sel"
                  style="width:200px"
                >
                  <mat-option *ngFor="let option of dropdownOptionEventTypesBar" [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select> -->
                <mat-form-field appearance="outline" class="fixed-select">
                  <mat-select [(ngModel)]="selectedEventBar" [multiple]="true" [panelWidth]="null">
                      <div class="search-all-option">
                          <mat-checkbox
                            [checked]="isAllSelected(selectedEventBar,dropdownOptionEventTypesBar)"
                            [indeterminate]="isIndeterminate(selectedEventBar,dropdownOptionEventTypesBar)"
                            (change)="selectedEventBar = toggleSelectAll($event,dropdownOptionEventTypesBar)">
                          </mat-checkbox>
                          <ngx-mat-select-search
                            [formControl]="eventFilterCtrl"
                            placeholderLabel="Search"
                            noEntriesFoundLabel="No options found">
                          </ngx-mat-select-search>
                      </div>
                      <div style="max-height: 195px; overflow-y: auto;">
                        <mat-option *ngFor="let d of filteredEvent | async" [value]="d" style="font-size: 13px;">
                      {{ d.value }}
                    </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              
              <p class="required">{{requiredMsg}}</p>
            </div>

          </div>
          <div class="row spacing">
            <div class="col-6">
              <button class="black-button" (click)="onBarClicked()">Apply</button>
            </div>
            <div class="col-6">
              <button class="black-button" (click)="resetBar()">Reset</button>
            </div>
          </div>
        </div>

      </div>
      <div style="position: relative">
        <ngx-ui-loader class="custom-loader" [loaderId]="'loader-02'"></ngx-ui-loader>
      </div>
      <div ngxUiLoaderBlurred *ngIf="barChartData.labels.length>0;else showBar" [loaderId]="'loader-02'" class="graph">      
         <canvas baseChart
        [data]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [type]="'bar'"
        (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)"> 
      </canvas>
      
      </div>
      <ng-template   #showBar>
        <div ngxUiLoaderBlurred [loaderId]="'loader-02'">
        <label class="hideGraph">{{showMessage1}}</label></div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>


  <mat-accordion>

    <mat-expansion-panel #panel class="mat-elevation-z0" (opened)="openPie()">
      <mat-expansion-panel-header class="header-container">
        <mat-panel-title> </mat-panel-title>
        <mat-panel-description class="bardesc">
          Percentage of Abnormals
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div
      class="px-3"
      *ngIf="errorMessage1 != null"
      class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4"
      role="alert"
    >
      <button
        type="button"
        class="btn-close"
        (click)="close()"
        data-bs-dismiss="alert"
        aria-label="close"
      ></button>
      <strong>{{ errorMessage1 }}</strong>
    </div>
              <div class="row d-flex
              mt-2
              icon-container
              ms-4
              kpibuttons">
                      <img
                            src="./assets/images/refresh_button.svg" title="Refresh" (click)="onPieClicked()"
                            style="width:60.5px; margin-top: 5px; cursor:pointer;"
                          />
                    <img
                      src="./assets/images/export_black.svg" title="Export"
                      (click)="onBtExport1()"
                      style="width:47px; margin-bottom: 10px; cursor:pointer;"
                    />
                 </div>
      <div class="row">
        <div class="col-2">
          <div class="row spacing">
            <div class="col-6">
              <label for="start">Start Date</label>
            </div>
            <div class="col-6">
              <input type="date" style="width: 134px;"  [(ngModel)]="startDatePie" onkeydown="return false" />
            </div>
          </div>

          <div class="row spacing">
            <div class="col-6">
              <label for="end">End Date</label>
            </div>
            <div class="col-6">
              <input type="date" style="width: 135px;" [max]="maxDate" [(ngModel)]="endDatePie" onkeydown="return false" />
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6"><label for="end">Domicile</label></div>
            <div class="col-6">
              <!-- <p-multiSelect
                [options]="dropdownDomicilePie"
                defaultLabel=""
                [showTransitionOptions]="'0ms'"
                optionLabel="value"
                [hideTransitionOptions]="'0ms'"
                [filter]="true"
                
                [(ngModel)]="selectedDomicilePie"
                [style]="{
                  'box-shadow': 'inset 0px 1px 6px #00000029',
                  height: '32px',
                  width: '200px',
                  float: 'left',
                  'font-size': '13px'
                }"
              >
              </p-multiSelect> -->
                <mat-select
                  [(ngModel)]="selectedDomicilePie"
                  [panelWidth]="null"
                  placeholder=""
                  class="dropdownOptions mat-sel diff"
                  style="width:200px"

                >
                  <mat-option *ngFor="let option of dropdownDomicilePie" [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select>
              
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6"><label for="end">Event Type</label></div>
            <div class="col-6">
                <!-- <mat-select
                  multiple
                  required
                  [(ngModel)]="selectedEventPie"
                  placeholder=""
                  [disableOptionCentering]="true"
                  class="mat-sel"
                  style="width:200px"
                >
                  <mat-option *ngFor="let option of dropdownEventTypesPie" [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select> -->
                <mat-form-field appearance="outline" class="fixed-select">
                  <mat-select [(ngModel)]="selectedEventPie" [multiple]="true" [panelWidth]="null">
                      <div class="search-all-option">
                          <mat-checkbox
                            [checked]="isAllSelected(selectedEventPie,dropdownEventTypesPie)"
                            [indeterminate]="isIndeterminate(selectedEventPie,dropdownEventTypesPie)"
                            (change)="selectedEventPie = toggleSelectAll($event,dropdownEventTypesPie)">
                          </mat-checkbox>
                          <ngx-mat-select-search
                            [formControl]="eventPieFilterCtrl"
                            placeholderLabel="Search"
                            noEntriesFoundLabel="No options found">
                          </ngx-mat-select-search>
                      </div>
                      <div style="max-height: 195px; overflow-y: auto;">
                        <mat-option *ngFor="let d of filteredEventPie | async" [value]="d" style="font-size: 13px;">
                      {{ d.value }}
                    </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              <p class="required">{{requiredMsg1}}</p>
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6">
              <button class="black-button" (click)="onPieClicked()">Apply</button>
            </div>
            <div class="col-6">
              <button class="black-button" (click)="resetPie()">Reset</button>
            </div>
          </div>
        </div>

      </div>
      <div style="position: relative">
        <ngx-ui-loader class="custom-loader" [loaderId]="'loader-03'"></ngx-ui-loader>
      </div>
      <div ngxUiLoaderBlurred *ngIf="chartData.datasets[0]?.data.length > 0 && chartLabels.length > 0; else showPie"
        [loaderId]="'loader-03'" class="pieGraph" >
        <canvas baseChart  style="height:300px !important;width:320px !important" [data]="chartData" [labels]="chartLabels" [options]="pieChartOptions" [type]="'pie'" >
          <!--  Use [type] instead of [chartType] -->
        </canvas>
      
      </div>
      <ng-template  #showPie>
        <div ngxUiLoaderBlurred [loaderId]="'loader-03'">
        <label class="hideGraph">{{showMessage2}}</label></div></ng-template>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-accordion>

    <mat-expansion-panel #panel class="mat-elevation-z0" (opened)="openLine()">
      <mat-expansion-panel-header  class="header-container">
        <mat-panel-title> </mat-panel-title>
        <mat-panel-description class="bardesc">
          Abnormals by Time Span
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div
      class="px-3"
      *ngIf="errorMessage2 != null"
      class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4"
      role="alert"
    >
      <button
        type="button"
        class="btn-close"
        (click)="close()"
        data-bs-dismiss="alert"
        aria-label="close"
      ></button>
      <strong>{{ errorMessage2 }}</strong>
    </div>
                  <div class="row d-flex
                  mt-2
                  icon-container
                  ms-4
                  kpibuttons">
                          <img
                                src="./assets/images/refresh_button.svg" title="Refresh" (click)="onLineClicked()"
                                style="width:60.5px;cursor:pointer;"
                              />
                        <img
                          src="./assets/images/export_black.svg" title="Export"
                          (click)="onBtExport2()"
                          style="width:47px; margin-bottom: 16px;cursor:pointer;"
                        />
                     </div>

      <div class="row">
        <div class="col-2">
          <div class="row spacing">
            <div class="col-6"><label for="start">Time Span</label></div>
            <div class="col-6">
                <mat-select style="width:137px"
                  [(ngModel)]="selectedSpan"
                  [panelWidth]="null"
                  class="dropdownOptions mat-sel diff"
                  [disableOptionCentering]="true"
                  panelClass="custom-panel"
                >
                  <mat-option *ngFor="let item of timespanlist" [value]="item">
                    {{ item }}
                  </mat-option>
                </mat-select>
              
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6"><label for="start">Start Date</label></div>
            <div class="col-6">
              <input *ngIf="selectedSpan != 'Monthly'" type="date" style="width: 134px;" [(ngModel)]="startDateLine" onkeydown="return false" />
              <input *ngIf="selectedSpan == 'Monthly'" type="month" style="width: 134px;" [(ngModel)]="startMonthLine" onkeydown="return false" />
            </div>
          </div>

          <div class="row spacing">
            <div class="col-6"><label for="end">End Date</label></div>
            <div class="col-6">
              <input *ngIf="selectedSpan != 'Monthly'" type="date" style="width: 135px;" [max]="maxDate" [(ngModel)]="endDateLine" onkeydown="return false" />
              <input *ngIf="selectedSpan == 'Monthly'" type="month" style="width: 135px;" [max]="maxMonth" [(ngModel)]="endMonthLine" onkeydown="return false" />
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6"><label for="end">Domicile</label></div>
            <div class="col-6">
                <mat-select
                  [(ngModel)]="selectedDomicileLine"
                  [panelWidth]="null"
                  placeholder=""
                  class="dropdownOptions mat-sel diff"
                  style="width:200px"
                >
                  <mat-option *ngFor="let option of dropdownDomicileLine" [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select>
              
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6"><label for="end">Event Type</label></div>
            <div class="col-6">
                <!-- <mat-select
                  multiple
                  required
                  [(ngModel)]="selectedEventLine"
                  placeholder=""
                  [disableOptionCentering]="true"
                  class="mat-sel"
                  style="width:200px"
                >
                  <mat-option *ngFor="let option of dropdownEventTypesLine" [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select> -->
                <mat-form-field appearance="outline" class="fixed-select">
                  <mat-select [(ngModel)]="selectedEventLine" [multiple]="true" [panelWidth]="null">
                      <div class="search-all-option">
                          <mat-checkbox
                            [checked]="isAllSelected(selectedEventLine,dropdownEventTypesLine)"
                            [indeterminate]="isIndeterminate(selectedEventLine,dropdownEventTypesLine)"
                            (change)="selectedEventLine = toggleSelectAll($event,dropdownEventTypesLine)">
                          </mat-checkbox>
                          <ngx-mat-select-search
                            [formControl]="eventLineFilterCtrl"
                            placeholderLabel="Search"
                            noEntriesFoundLabel="No options found">
                          </ngx-mat-select-search>
                      </div>
                      <div style="max-height: 195px; overflow-y: auto;">
                        <mat-option *ngFor="let d of filteredEventLine | async" [value]="d" style="font-size: 13px;">
                      {{ d.value }}
                    </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              <p class="required">{{requiredMsg2}}</p>
            </div>
          </div>
          <div class="row spacing">
            <div class="col-6">
              <button class="black-button" (click)="onLineClicked()">Apply</button>
            </div>
            <div class="col-6">
              <button class="black-button" (click)="resetLine()">Reset</button>
            </div>
          </div>
        </div>
      </div>
      <div style="position: relative">
        <ngx-ui-loader class="custom-loader" [loaderId]="'loader-04'"></ngx-ui-loader>
      </div>
      <div ngxUiLoaderBlurred *ngIf="lineChartLabels.length>0 && lineChartData.length>0;else showLine" [loaderId]="'loader-04'" class="lineGraph">
        <canvas
          baseChart
          [datasets]="lineChartData"
          [labels]="lineChartLabels"
          [type]="lineChartType"
          [options]="lineChartOptions"
        >
        </canvas>
      </div>
      <ng-template  #showLine>
        <div ngxUiLoaderBlurred [loaderId]="'loader-04'">
        <label class="hideGraph">{{showMessage}}</label></div></ng-template>
    </mat-expansion-panel>
  </mat-accordion>
  <!-- </div>  -->
</div>
<!-- <div style="margin-top: 20% !important;">
  <app-footer></app-footer>
</div> -->


